export const STAY = 1;
export const FORWARD = 2;
export const REVERSE = 3;
export const FORWARD_REVERSE = 4;
export const BROWNIAN = 5;
